import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from '@mui/material';

import type { ScheduleType } from '@/types/schedule';

interface ScheduleTypeSelectorProps {
  value: ScheduleType;
  onChange: (type: ScheduleType) => void;
  disabled?: boolean;
}

const SCHEDULE_TYPE_OPTIONS: Array<{
  value: ScheduleType;
  label: string;
  description: string;
}> = [
  {
    value: 'daily',
    label: 'Daily Schedule',
    description: 'Run once per day at a specific time',
  },
  {
    value: 'repeating',
    label: 'Repeating Schedule',
    description: 'Run at regular intervals (every X minutes or hours)',
  },
  {
    value: 'cron',
    label: 'Advanced',
    description: 'Use a cron expression for complex scheduling',
  },
];

export const ScheduleTypeSelector = ({
  value,
  onChange,
  disabled = false,
}: ScheduleTypeSelectorProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange(event.target.value as ScheduleType);
  };

  return (
    <FormControl component="fieldset" disabled={disabled}>
      <FormLabel component="legend" sx={{ mb: 1 }}>
        Automate Your Integration
      </FormLabel>
      <RadioGroup value={value} onChange={handleChange}>
        <Stack spacing={1}>
          {SCHEDULE_TYPE_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              value={option.value}
              control={<Radio />}
              label={
                <Stack spacing={0}>
                  <Typography variant="body1">{option.label}</Typography>
                  <Typography variant="caption" color="text.secondary">
                    {option.description}
                  </Typography>
                </Stack>
              }
              sx={{
                alignItems: 'flex-start',
                '& .MuiRadio-root': {
                  pt: 0.5,
                },
              }}
            />
          ))}
        </Stack>
      </RadioGroup>
    </FormControl>
  );
};
